import { InferType, q } from "groqd";

export const ImageQuery = q.object({
    _type: q.literal("image"),
    _key: q.string(),
    alt: q.string().optional(),
    asset: q.object({
        _ref: q.string(),
        _type: q.literal("reference")
    })
});

export type ImageBlock = InferType<typeof ImageQuery>;

export const CodeQuery = q.object({
    _type: q.literal("code"),
    _key: q.string(),
    code: q.string(),
    language: q.string()
});

export type CodeType = InferType<typeof CodeQuery>;

export const NoteQuery = q.object({
    _type: q.literal("note"),
    _key: q.string(),
    body: q.array(q.contentBlock()),
    startOpen: q.boolean(),
    title: q.string()
});

const TableRow = q.object({
    cells: q.array(q.string()),
    _type: q.literal("tableRow"),
    _key: q.string()
});

export const TableQuery = q.object({
    _type: q.literal("table"),
    _key: q.string(),
    rows: q.array(TableRow)
});

export type TableType = InferType<typeof TableQuery>;

export const CustomTableQuery = q.object({
    _type: q.literal("customTable"),
    _key: q.string(),
    data: q.object({
        rows: q.array(TableRow)
    }),
    firstColumnIsHeader: q.boolean(),
    firstRowIsHeader: q.boolean()
});

export type CustomTableType = InferType<typeof CustomTableQuery>;

export const RouteQuery = q.object({
    _rev: q.string(),
    _type: q.literal("route"),
    _id: q.string(),
    _createdAt: q.string(),
    _updatedAt: q.string(),
    title: q.string(),
    geojson: q.unknown() // todo: define geojson type

    // q.object(
    // {
    // features: q.array(
    //         q.object({
    //             geometry: q.object({
    //                 coordinates: q.array(q.array(q.number())),
    //                 type: q.string()
    //             }),
    //             _key: q.string(),
    //             type: q.string(),
    //             properties: q.object({
    //                 time: q.string(),
    //                 desc: q.string().optional(),
    //                 coordTimes: q.array(q.string()),
    //                 name: q.string(),
    //                 heartRates: q.array(q.number()).optional(),
    //                 type: q.string().optional()
    //             })
    //         })
    //     ),
    //     type: q.string()
    // }
    // )
});
